'use client';
import { createContextStore } from '../../utils/context-store.js';
const getSideNavigationInitializer = ({ initialExpanded, }) => (set, get) => ({
    expanded: initialExpanded ?? true,
    onExpandedToggle: () => {
        set({
            expanded: !get().expanded,
        });
    },
    onExpandedChange: (expanded) => {
        set({
            expanded,
        });
    },
});
const { Provider: SideNavigationProvider, SyncPropWithStore: SyncPropWithSideNavigationStore, useStore: useSideNavigation, useStoreApi: useSideNavigationApi, } = createContextStore();
export { SideNavigationProvider, SyncPropWithSideNavigationStore, useSideNavigation, useSideNavigationApi, getSideNavigationInitializer, };
//# sourceMappingURL=side-navigation.store.js.map